import {
  type ReportConfigId,
  type ReportConfigRunInput,
  type ReportConfigRunSuccess,
  toResponseError,
} from '@terros/common'
import { useTantalimMutation } from '../../mutation'
import { type AddHookResponse, mutationAdd } from '../../hooks'

type RunHookResponse = Omit<AddHookResponse<ReportConfigRunInput, void>, 'add' | 'isAdding'> & {
  run: (reportConfigId: ReportConfigId) => Promise<void>
  isRunning: boolean
}

export function useRunReportConfig(): RunHookResponse {
  const mutation = useTantalimMutation<ReportConfigRunInput, ReportConfigRunSuccess>({
    url: '/report/config/run',
  })

  async function run(reportConfigId: ReportConfigId): Promise<void> {
    try {
      await mutation.mutateAsync({ reportConfigId })
    } catch (error) {
      throw toResponseError(error)
    }
  }

  const response = mutationAdd(mutation, run)

  return {
    ...response,
    run: response.add,
    isRunning: response.isAdding,
  }
}
